<template>
    <b-modal id="createModal" ref="modal" title="Create a variety group" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Variety Group Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import listVarietyGroupQuery from '@views/VarietyGroups/Browse/queryListVarietyGroups.graphql';
import createVarietyGroupMutation from '@views/VarietyGroups/CreateModal/mutationCreateVarietyGroup.graphql';

export default {
  name: 'create-modal',
  apollo: {},
  props: {
    close: {
      type: Function,
      required: true,
    },
    cropType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: createVarietyGroupMutation,
            refetchQueries: [
              { query: listVarietyGroupQuery, variables: { input: { crop_type_id: this.cropType.id, include_deleted: true } } },
              { query: listVarietyGroupQuery, variables: { input: { crop_type_id: this.cropType.id } } },
            ],
            variables: {
              input: {
                crop_type_id: this.cropType.id,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Variety group created!');
            this.close();
          })
          .catch(err => this.$mapGraphQLError(err))
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
